// extracted by mini-css-extract-plugin
export default {"normalRow":"CustomersTable_normalRow__JUXuL","selectedRow":"CustomersTable_selectedRow__DNDpg"};